import { useQuery } from '@tanstack/react-query';
import { BENEFICIARY_RESOURCE_DOCUMENT_KEY } from '../../utils/constants/queryKeys';
import { getBeneficiaryResourceDocument } from '../services/fn-api/Beneficiary';

export const useGetBeneficiaryResourceDocument = (caseId: number) => {
  return useQuery({
    queryKey: [BENEFICIARY_RESOURCE_DOCUMENT_KEY, caseId],
    queryFn: () => getBeneficiaryResourceDocument(caseId),
    enabled: !!caseId,
  });
};
